import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom'
import { RootStoreContext } from '../stores/RootStore'

interface IProps extends RouteProps {
    component: React.ComponentType<RouteComponentProps<any>>,
    Requirments: string[] | null
}

const PrivateRoute: React.FC<IProps> = ({ component: Component, Requirments, ...rest }) => {
    const rootStore = useContext(RootStoreContext);
    const { isLoggedIn, HasRoles } = rootStore.userStore;
    return (
        <Route
            {...rest}
            render={
                (props) => isLoggedIn && (Requirments !== null ? HasRoles(Requirments) : true) ? <Component {...props} /> : <Redirect to={'/'} />
            }
        />
    )
}

export default observer(PrivateRoute)